import axios from '@axios'

/**
 * @fileoverview Servizio per la gestione delle funzionalità BRT (Bartolini)
 * @author web-settore8
 * @created 2025-04-11
 */

/**
 * Service per la gestione delle funzionalità BRT (Bartolini)
 */
class BrtService {
  /**
   * Recupera la lista dei punti di raccolta (PUDO) BRT
   *
   * @param {Object} params - Parametri per la richiesta
   * @returns {Promise<Array>} Promise che restituisce la lista dei punti di raccolta
   * @throws {Error} Se la richiesta fallisce
   *
   * @example
   * // Recupera tutti i punti di raccolta
   * brtService.getPudoList()
   *   .then(points => console.log(points))
   *   .catch(error => console.error(error));
   */
  static getPudoList(params = {}) {
    return new Promise((resolve, reject) => {
      axios
        .post('/api/brt/pudo-list', params)
        .then(response => {
          resolve(response.data)
        })
        .catch(error => {
          // eslint-disable-next-line no-console
          console.error('Errore nel recupero dei punti di raccolta BRT:', error)
          reject(error)
        })
    })
  }
}

// Esporta un'istanza singola del servizio
export default BrtService
